import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChipNotch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 8,
	viewBox: "0 0 32 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_3327_38342)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.99487e-07 7.99807C1.16595 7.99807 2.33156 8.0033 3.49751 7.99192C4.61344 7.98084 5.86243 7.96515 6.9484 7.59499C8.1215 7.19498 8.89812 6.49559 9.6795 5.6725C10.2421 5.08049 11.3471 3.8174 11.8851 3.20755C12.3255 2.70754 13.1876 1.71922 13.6582 1.24106C14.2507 0.639514 14.9831 0.000120932 16.0003 0.000121021C17.0176 0.00012111 17.7496 0.639514 18.3418 1.24045C18.8124 1.7183 19.6745 2.70723 20.1152 3.20693C20.6526 3.81679 21.7576 5.07988 22.3205 5.67189C23.1032 6.49498 23.8785 7.19437 25.0513 7.59438C26.1376 7.96361 27.3869 7.98023 28.5022 7.9913C29.6684 8.00269 30.8341 7.99746 32 7.99746",
			fill: "#DFCBF5",
			fillOpacity: .1
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3327_38342",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 8,
			fill: "white",
			transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 32 2.79753e-06)"
		})
	}) })]
});
export default SvgChipNotch;
